import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IonDatetime, IonModal } from '@ionic/angular';

@Component({
  selector: 'time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimePickerComponent {

  @ViewChild(IonModal) modal!: IonModal;
  @ViewChild(IonDatetime) picker!: IonDatetime;

  @Input() title: string = '';
  @Input() value: string = '00:00:00';
  @Input() disabled: boolean = false;
  @Output() onTimeSelected: EventEmitter<string> = new EventEmitter();

  public pickerId = `picker-${Math.random() * 1000}`;

  public onApply() {
    this.modal.dismiss(`${<string>this.picker.value}:00`);
    this.onTimeSelected.emit(<string>this.picker.value)
  }

  // prevent swipe down to close
  public async canDismiss(data?: any, role?: string) {
    return role !== 'gesture';
  }
}
